import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import moment from 'moment'
import { Col, Row } from 'react-bootstrap'
import { CerealDropdown } from '../../../Forms/SharedComponents/containers'
import { obtenerAlmacenajeEspecial } from '../../actions/listados'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_ALMACENAJE_ESPECIAL } from '../../../../config/forms'
import TotalAlmacenajeEspecialView from '../../components/listados/TotalAlmacenajeEspecialView'

function TotalAlmacenajeEspecial (props) {
  const { obtenerAlmacenajeEspecial, cereal } = props
  const [fechaDesde, setFechaDesde] = useState(new Date())
  const [fechaHasta, setFechaHasta] = useState(new Date())
  const [show, setShow] = useState(false)

  const handleSubmit = () => {
    setShow(true)
    obtenerAlmacenajeEspecial(fechaDesde, fechaHasta, cereal)
  }

  const actualizarFechas = (fechaD, fechaH) => {
    setFechaDesde(fechaD)
    setFechaHasta(fechaH)
  }

  return (
    <>
      <h2>Total almacenaje especial de mercaderia</h2>
      { !show && <p> Seleccione las fechas y el cereal para obtener el total de almacenaje especial.</p> }
      <Row style={{ alignItems: 'center', marginTop: '2%' }}>
        <Col md={4} style={{ margin: '12px' }}>
          <DatePicker
            selectRange
            disabledFuture
            locale='es'
            onDateChange={actualizarFechas}
            fechaDesde={moment(fechaDesde).format('DD-MM-YYYY')}
            fechaHasta={moment(fechaHasta).format('DD-MM-YYYY')}
            titulo='Seleccione las fechas'
            value='fechas'
          />
        </Col>
        <Col md={4} style={{ margin: '0 1%' }}>
          <CerealDropdown />
        </Col>
        <Col md={3}>
          <Button
            onClick={handleSubmit}
            size='small'
            variant='contained'
            color='primary'
            disabled={!cereal}
            style={{ outline: 'none' }}
          >
                        Consultar
          </Button>
        </Col>
      </Row>

      { show && <TotalAlmacenajeEspecialView /> }
    </>
  )
}

const selector = formValueSelector(FORM_ALMACENAJE_ESPECIAL)

const mapStateToProps = (state) => ({
  cereal: selector(state, 'cereal')
})

const mapActionsToProps = {
  obtenerAlmacenajeEspecial
}

const withReduxForm = reduxForm({
  form: FORM_ALMACENAJE_ESPECIAL
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(TotalAlmacenajeEspecial))
